
import Swal from "sweetalert2";

export default {
    methods: {
        fireSwal(title, type){
            return Swal.fire({
                title: title,
                text: "",
                icon: type,
                showCancelButton: true,
                confirmButtonColor: '#5F2EEA',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes'
              });
              
        }
    }
}